import React, { useContext } from 'react'

import { Trans, useTranslation } from 'react-i18next'

import Button from '@components/shared/Button'
import Dialog from '@components/shared/Dialog'
import { TitleContext } from '@providers/TitleProvider'
import { useDialogStore } from '@stores/dialog.store'
import { useSession } from '@stores/globalData/globalData.store'
import ApiRoutes from '@utils/api-routes'
import http from '@utils/http'
import PageRoutes from '@utils/page-routes'

const StopSellingDialog: React.FC = () => {
  const { t } = useTranslation()
  const { title } = useContext(TitleContext)
  const closeDialog = useDialogStore((s) => s.closeDialog)
  const openDialog = useDialogStore((s) => s.openDialog)
  const session = useSession()

  const product = title.product

  const stopSelling = async (): Promise<void> => {
    closeDialog('stop_selling')
    if (!product) return
    const [resp, errors] = await http.post(ApiRoutes.deactivateProduct(), { uuid: product.uuid })
    if (!resp) {
      console.error(errors)
      return
    }
    window.location.href = resp.data.score_url
  }

  const distributionEnabled = session.gatedFeatures.showGatedFeature('contentDistributionEnabled')
  return (
    <Dialog
      name="stop_selling"
      title={t('action.stopSelling')}
      maxWidth={distributionEnabled ? 490 : 600}>
      {distributionEnabled ? (
        <p className="py-1">
          <Trans
            i18nKey="messages.stopSellingDistribute"
            link={PageRoutes.musicEditing(title, false)}>
            If you need to make changes to your score use
            <button
              type="button"
              className="orange-link"
              onClick={() => openDialog('edit_score_details', { closeOthers: true })}>
              Edit Score
            </button>{' '}
            to return the original score, and publish an update.
            <br />
            <br />
            If you stop selling your score will be removed from Noteflight and other sheet music
            sites. Removal of the score can take up to 24 hours.
          </Trans>
        </p>
      ) : (
        <>
          <p className="font-semibold">{t('messages.stopSelling1')}</p>
          <p className="py-1">
            {t('messages.stopSelling2')}
            <a
              title={t('action.editScoreDetails')}
              href={PageRoutes.musicEditing(title, false)}
              className="text-orange cursor-pointer hover:underline disabled:hover:no-underline disabled:cursor-not-allowed">
              {t('action.editScoreDetails')}
            </a>
            {t('messages.stopSelling2b')}
          </p>
          <p className="py-1">{t('messages.stopSelling3')}</p>
        </>
      )}
      <div className="flex flex-row justify-end w-full mt-4">
        <Button variant="secondary" onClick={() => closeDialog('stop_selling')}>
          {t('action.cancel')}
        </Button>
        <Button className="ml-2" variant="primary" onClick={stopSelling}>
          {t('action.stopSelling')}
        </Button>
      </div>
    </Dialog>
  )
}

export default StopSellingDialog
